const SUFFIX = '.sip.twilio.com';

function slug(displayName) {
  let raw = String(displayName || '');
  if (raw.includes('@')) raw = raw.split('@')[0];
  let value = raw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-{2,}/g, '-').replace(/^-|-$/g, '');
  if (!value || !/^[a-z]/.test(value)) value = value ? `tenant-${value}` : 'tenant';
  return value.replace(/^-|-$/g, '');
}

export async function suggestSipDomain(displayName, tenantId) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(tenantId)));
  const suffix = [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('').slice(0, 4);
  const budget = 48 - 'sb-'.length - 1 - suffix.length;
  const trimmed = slug(displayName).slice(0, budget).replace(/-$/g, '') || 'tenant';
  return `sb-${trimmed}-${suffix}${SUFFIX}`;
}
